import { FileText, MessagesSquare, PenLine, Tags, Clock } from "lucide-react";

/* Blog detail page tour. No mobile mockup exists for this screen, so the steps
   are authored to match the page's own layout in the house tour style:
   article → comments → leave a comment → categories → recent posts.
   The comments step targets the stable `.blog-comments-section` class (present
   in every load/empty/list state). The sidebar steps auto-skip when a section
   isn't rendered (no categories / no recent posts, or sidebar hidden). */
export default function getBlogDetailTourSteps() {
  return [
    {
      cardSelector: '[data-tour="bd-article"]',
      targetSelector: '[data-tour="bd-article"]',
      icon: <FileText />,
      title: "The article",
      text: "Read the full post here — the title, date, and topics up top.",
    },
    {
      cardSelector: ".blog-comments-section",
      targetSelector: ".blog-comments-section",
      icon: <MessagesSquare />,
      title: "Comments",
      text: "See what other readers are saying about this post.",
    },
    {
      cardSelector: '[data-tour="bd-comment-form"]',
      targetSelector: '[data-tour="bd-comment-form"]',
      icon: <PenLine />,
      title: "Leave a comment",
      text: "Join the conversation and share your own thoughts.",
    },
    {
      cardSelector: '[data-tour="bd-categories"]',
      targetSelector: '[data-tour="bd-categories"]',
      icon: <Tags />,
      title: "Browse by category",
      text: "Explore more posts on a topic that interests you.",
    },
    {
      cardSelector: '[data-tour="bd-recent"]',
      targetSelector: '[data-tour="bd-recent"]',
      icon: <Clock />,
      title: "Recent posts",
      text: "Jump straight to another recent article.",
    },
  ];
}
